import React from 'react'
import { withStyles, ListItem } from '@material-ui/core';
import PropTypes from 'prop-types';

const style = theme => ({
	root: {
		'&:hover': {
			background: theme.palette.primary.light,
			color: theme.palette.secondary.contrastText
		}
	}
})

function ListElement({
	classes,
	onClick,
	onMouseEnter,
	onMouseLeave,
	label,
	disabled,
}) {
	return (
		<ListItem
			className={classes.root}
			button
			onClick={onClick}
			disabled={disabled}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			{label}
		</ListItem>
	)
}

ListElement.propTypes = {
	classes: PropTypes.any,
}

ListElement.defaultProps = {
}

export default withStyles(style)(ListElement);